import Flex from "../../../shared/components/Flex";
import PillButton from "../../../shared/components/PillButton";
import useDevice from "../../../shared/hooks/useDevice";
import { useAppDispatch, useAppSelector } from "../../../shared/store/store";
import { setFilter, setIsStatusBoardOpen, setSelectedSensor } from "../slice/sensorDashboardSlice";
import styles from "./css/SensorStatusMobile.module.css";
import Spacer from "../../../shared/components/Spacer";
import Text from "../../../shared/components/Text";
import statusToColor from "../utils/statusToColor";

type SensorStatusMobileProps = {
    isStatusBoardOpen?: boolean;
};

function SensorStatusMobile({ isStatusBoardOpen }: SensorStatusMobileProps) {
    const device = useDevice();
    const sensorDashboardFilter = useAppSelector(state => state.sensorDashboard.filter);
    const visibleMarkerCounts = useAppSelector(state => state.sensorDashboard.visibleMarkerCounts);
    const dispatch = useAppDispatch();

    // 실제 마커 수를 사용하여 counts 생성
    const counts = {
        "전체": {
            count: visibleMarkerCounts["전체"] ?? 0,
            color: statusToColor("전체").color
        },
        "안전": {
            count: visibleMarkerCounts["안전"] ?? 0,
            color: statusToColor("안전").color
        },
        "주의": {
            count: visibleMarkerCounts["주의"] ?? 0,
            color: statusToColor("주의").color
        },
        "경보": {
            count: visibleMarkerCounts["경보"] ?? 0,
            color: statusToColor("경보").color
        },
        "점검": {
            count: visibleMarkerCounts["점검"] ?? 0,
            color: statusToColor("점검").color
        }
    };

    // 모바일에서만 상단에 표시 (statusboard가 열려있을 때는 숨김)
    if (device !== "mobile" || isStatusBoardOpen) return null;

    const handleFilterClick = (filter: string) => {
        dispatch(setFilter(filter));
        dispatch(setIsStatusBoardOpen(true));
        dispatch(setSelectedSensor(null));
    };

    return (
        <div className={styles.container}>
            <Flex gap={10} className={styles["no-scrollbar"]} style={{overflowX: "auto"}}>
                <PillButton fullWidth variant={sensorDashboardFilter === "전체" ? "black" : "white"} height={39} paddingX={22} paddingY={10} onClick={() => handleFilterClick("전체")}>
                    <Text variant={"span"} color={sensorDashboardFilter === "전체" ? "white" : counts["전체"]?.color} weight={"bold"}>
                        {counts["전체"]?.count ?? 0}
                    </Text>
                    전체
                </PillButton>
                <PillButton fullWidth variant={sensorDashboardFilter === "안전" ? "black" : "white"} height={39} paddingX={22} paddingY={10} onClick={() => handleFilterClick("안전")}>
                    <Text variant={"span"} color={sensorDashboardFilter === "안전" ? "white" : counts["안전"]?.color} weight={"bold"}>
                        {counts["안전"]?.count ?? 0}
                    </Text>
                    안전
                </PillButton>
                <PillButton fullWidth variant={sensorDashboardFilter === "주의" ? "black" : "white"} height={39} paddingX={22} paddingY={10} onClick={() => handleFilterClick("주의")}>
                    <Text variant={"span"} color={sensorDashboardFilter === "주의" ? "white" : counts["주의"]?.color} weight={"bold"}>
                        {counts["주의"]?.count ?? 0}
                    </Text>
                    주의
                </PillButton>
                <PillButton fullWidth variant={sensorDashboardFilter === "경보" ? "black" : "white"} height={39} paddingX={22} paddingY={10} onClick={() => handleFilterClick("경보")}>
                    <Text variant={"span"} color={sensorDashboardFilter === "경보" ? "white" : counts["경보"]?.color} weight={"bold"}>
                        {counts["경보"]?.count ?? 0}
                    </Text>
                    경보
                </PillButton>
                <PillButton fullWidth variant={sensorDashboardFilter === "점검" ? "black" : "white"} height={39} paddingX={22} paddingY={10} onClick={() => handleFilterClick("점검")}>
                    <Text variant={"span"} color={sensorDashboardFilter === "점검" ? "white" : counts["점검"]?.color} weight={"bold"}>
                        {counts["점검"]?.count ?? 0}
                    </Text>
                    점검
                </PillButton>
                <Spacer size={15}/>
            </Flex>
        </div>
    )
}

export default SensorStatusMobile;